import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
});

export default new Vuex.Store({
  state: {
    lang: "es",
    loggedIn: false,
    user: false,
    token: false,
    //roles: [],
    rols: [],
    //modules: [],
    availableLangs: [],
    not_count: 0,
    msalConf: {
      auth: {
        redirectUri: "https://bonsai-qa-webapp.azurewebsites.net/index.html#/login"
        //redirectUri: 'http://localhost:4200/'
      }
    },
    loginRequest: {
      scopes: ["user.read", "openid"]
    },
    order: {},
    detail: {},
    loginDate: new Date(),
    isRecentlyLoggedIn: false,
  },
  mutations: {
    SET_LANG(state, payload) {
      state.lang = payload;
    },
    SET_LOGGED_IN(state, payload) {
      state.loggedIn = payload;
    },
    SET_USER(state, payload) {
      state.user = payload;
    },
    SET_TOKEN(state, payload) {
      state.token = payload;
    },
    /*SET_ROLES(state, payload) {
      state.roles = payload;
    },*/
    SET_ROLS(state, payload) {
      state.rols = payload;
    },
    /*SET_MODULES(state, payload) {
      state.modules = payload;
    },*/
    SET_AVAILABLE_LANGS(state, payload) {
      state.availableLangs = payload;
    },
    SET_NOT_COUNT(state, payload) {
      state.not_count = payload;
    },
    SET_ORDER(state, payload) {
      state.order = payload;
    },
    SET_DETAIL(state, payload) {
      state.detail = payload;
    },
    SET_LOGIN_DATE(state, payload) {
      state.loginDate = payload
    },
    SET_IS_RECENTLY_LOGGED_IN(state, payload) {
      state.isRecentlyLoggedIn = payload
    }
  },
  actions: {},
  plugins: [vuexLocal.plugin]
});
